import { ComponentProps, ReactNode, useContext } from 'react';
import clsx from 'clsx';
import { OpImage } from 'components/customAntd/DLS/OpImage/OpImage';
import { OpSkeleton } from 'components/customAntd/DLS/OpSkeleton/OpSkeleton';
import { OpFormContext } from '../../OpFormContext';
import { OpForm } from '../../OpForm';

interface IOpFormImageProps extends ComponentProps<typeof OpImage> {
  formItemClassName?: string;
  isLoading?: boolean;
  loadingPlaceholder: ReactNode;
}

export const OpFormImage = ({
  // Form Item props
  formItemClassName,

  // For skeleton loading state
  isLoading,

  loadingPlaceholder,
  ...elementProps
}: IOpFormImageProps) => {
  /** The Form is wrapped in a provider that passes the loading context
   *  to the component */
  const { isDataLoading } = useContext(OpFormContext);
  const styles: { width?: string | number; height?: string | number } = {};
  if (elementProps.width) {
    styles.width = elementProps.width;
  }
  if (elementProps.height) {
    styles.height = elementProps.height;
  }

  const loadingContent = loadingPlaceholder ? (
    <OpSkeleton.Node style={styles} active>
      {loadingPlaceholder}
    </OpSkeleton.Node>
  ) : (
    <OpSkeleton.Image style={styles} active />
  );

  return (
    <OpForm.Item className={clsx('op-form-image', formItemClassName)}>
      {isDataLoading || isLoading ? (
        loadingContent
      ) : (
        <OpImage {...elementProps} />
      )}
    </OpForm.Item>
  );
};
